export default "/_next/static/images/win-min-ca299551447c7e8b5fe53902233162ae.png";